import { Injectable } from '@angular/core';
import { TranslateService as NgxTranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root',
})
export class TranslateService {
  constructor(private ngxTranslateService: NgxTranslateService) {}

  // Dil ayarını değiştirme
  changeLanguage(lang: string) {
    this.ngxTranslateService.use(lang);
  }

  // Anlık çeviri yapma
  instant(key: string | Array<string>, interpolateParams?: any): string | any {
    return this.ngxTranslateService.instant(key, interpolateParams);
  }

  // Asenkron çeviri yapma
  get(key: string | Array<string>, interpolateParams?: any) {
    return this.ngxTranslateService.get(key, interpolateParams);
  }
}
